import React, { useEffect, useState, useContext } from 'react';
import { Paper, Grid, Container } from '@material-ui/core';
import Content from 'components/Content';
import Chart from '../Chart';
import Deposits from '../Deposits';
import Orders from '../Orders';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { UserContext } from "../contexts";
import { getDateNow } from '../utils/helpers';
import { sendGetRequest } from '../utils/api';

import _ from 'lodash'
import headerImage from 'assets/eams.jpg';


const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
	},
	toolbar: {
		paddingRight: 24, // keep right padding when drawer closed
	},
	toolbarIcon: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-end',
		padding: '0 8px',
		...theme.mixins.toolbar,
	},
	appBar: {
		zIndex: theme.zIndex.drawer + 1,
		transition: theme.transitions.create(['width', 'margin'], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen,
		}),
	},
	appBarShift: {
		marginLeft: drawerWidth,
		width: `calc(100% - ${drawerWidth}px)`,
		transition: theme.transitions.create(['width', 'margin'], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen,
		}),
	},
	menuButton: {
		marginRight: 36,
	},
	menuButtonHidden: {
		display: 'none',
	},
	title: {
		flexGrow: 1,
	},
	drawerPaper: {
		position: 'relative',
		whiteSpace: 'nowrap',
		width: drawerWidth,
		transition: theme.transitions.create('width', {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen,
		}),
	},
	drawerPaperClose: {
		overflowX: 'hidden',
		transition: theme.transitions.create('width', {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen,
		}),
		width: theme.spacing(7),
		[theme.breakpoints.up('sm')]: {
			width: theme.spacing(9),
		},
	},
	appBarSpacer: theme.mixins.toolbar,
	content: {
		flexGrow: 1,
		height: '100vh',
		overflow: 'auto',
	},
	container: {
		paddingTop: theme.spacing(4),
		paddingBottom: theme.spacing(4),
	},
	paper: {
		padding: theme.spacing(2),
		display: 'flex',
		overflow: 'auto',
		flexDirection: 'column',
	},
	fixedHeight: {
		height: 240,
	},
	imageSize: {
		height: '100%',
		width: '100%',
	},
	customChartHeight:{
		height: 600,
	}
}));

const Home = () => {
	const classes = useStyles();
	const context = useContext(UserContext);
	const [rows, setRows] = useState([]);

	const [quickSummaryRows, setQuickSummaryRows] = useState([]);

	const fixedHeightPaper = clsx(classes.paper, classes.customChartHeight);

	useEffect(() => {
		if(_.isEmpty(context.userInfo.role)) return;	

		const getData = async()=>{
			//TO DO IN MIDDLEWARE: IF USER IS NOT ADMIN THEN FILTER BASED ON THE USER ID 
			const res = await sendGetRequest(`/reports/overall`);
			console.log(res);

			if(res.data !== 'Access Denied'){
				setRows(res.data);
			}

			const res1 = await sendGetRequest(`/reports/quicksummary`);
			console.log(res1);
			if(res1){
					setQuickSummaryRows(res1.data);
			}
		
		}
	
		getData();
		
		return () => {
		
		}
	}, [context.userInfo]);

	
	return (
		<Content>
			
			{
				context.userInfo.user && context.userInfo.user.length > 0 ? 
				<Grid container spacing={3}>
				
				<Grid item xs={12} md={12} lg={12}>
					<Chart data = {quickSummaryRows} rows = { rows }/>
				</Grid>
				
				</Grid>
				:
				<Container fixed>
					<img className={classes.imageSize} src={headerImage}/>
				</Container>
				
			}
			
			
		</Content>
	);
};

export default Home;
